
import './App.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import {BrowserRouter,Routes, Route} from 'react-router-dom'
import Login from './components/login/Login';
import Home from './components/Home/Home';
import Products from './components/Products/Products';
import Masters from './components/Masters/Masters';
import Orders from './components/Masters/Orders/Orders';
import Users from './components/Masters/users/Users';
import Cms from './components/Masters/Cms/Cms';
import Dashboard from './components/Home/Dashboard';
import UserHome from './components/Masters/users/UserHome';
import Loginprotectedroute from './components/common/routeprotector/Loginprotectedroute';
import ProtectedRoute from './components/common/routeprotector/ProtectedRoute';
import Proddetail from './components/Products/Proddetail';
import Notifications from './components/Home/Notifications';
import BackupPage from './components/Backup/BackupPage';
function App() {
  return (
    <div> 
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Loginprotectedroute> <Login /></Loginprotectedroute>} />
          <Route path='/home' element={<ProtectedRoute> <Home /> </ProtectedRoute> } >
          <Route path='/home' element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />
          <Route path='products' element={<ProtectedRoute> <Products /> </ProtectedRoute>} />
          <Route path='prod/:id' element={<ProtectedRoute> <Proddetail /> </ProtectedRoute>} />
          <Route path='masters' element={<ProtectedRoute> <Masters /> </ProtectedRoute>} /> 
          <Route path='orders' element={<ProtectedRoute> <Orders /> </ProtectedRoute>} /> 
          <Route path='cms' element={<ProtectedRoute> <Cms /> </ProtectedRoute>} /> 
          <Route path='userhome' element={<ProtectedRoute> <UserHome /></ProtectedRoute> } /> 
          <Route path='users' element={<ProtectedRoute> <Users /> </ProtectedRoute>} />
          <Route path='notifications' element={<ProtectedRoute> <Notifications /> </ProtectedRoute>} />
          <Route path='backup' element={<ProtectedRoute> <BackupPage /> </ProtectedRoute>} />
          </Route>
          <Route path='*' element={<div className='text-center mt-5'>Error Page Not Found</div>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
